import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Sidebar from './Sidebar';

/**
 * Desktop rail and a temporary mobile menu. Account, project, theme and
 * notifications sit at the sidebar's foot on either layout.
 */
export default function AppShell() {
  const { t: translate } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setMobileOpen(false); }, [location.pathname, location.search]);
  return (
    <Box sx={{ display: 'flex', bgcolor: 'background.default', height: '100dvh', overflow: 'hidden' }}>
      <Sidebar open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <Box
        component="main"
        tabIndex={0}
        sx={{
          flexGrow: 1,
          minWidth: 0,
          minHeight: 0,
          p: { xs: 2, md: 4 },
          overflow: 'auto',
          scrollbarGutter: 'stable',
        }}
      >
        <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 1, mb: 2 }}>
          <IconButton aria-label={translate('shell.openMenu')} onClick={() => setMobileOpen(true)}><MenuIcon /></IconButton>
          <Typography fontWeight={700}>Evolve Analytics</Typography>
        </Box>
        <Outlet />
      </Box>
    </Box>
  );
}
